import React, { useState } from 'react';

import { Portal } from 'react-portal';

import MarkdownContent from '../MarkdownContent';

import { Link, useStaticQuery, graphql } from 'gatsby';

import Button from '../Button/Button';
import KeywordRotator from './KeywordRotator';

import ReelSprites from '../../../data/img/reel-sprites.jpg';
import HomeVideoJPG from '../../assets/videos/tablets.jpg';
import HomeVideoMP4 from '../../assets/videos/tablets.mp4';
import HomeVideoWEBM from '../../assets/videos/tablets.webm';
import { ReactComponent as ApecLogo } from '../../assets/svg/logos/apec.svg';
import { ReactComponent as ClarinsLogo } from '../../assets/svg/logos/clarins.svg';
import { ReactComponent as VeoliaLogo } from '../../assets/svg/logos/veolia.svg';
import { ReactComponent as SGLogo } from '../../assets/svg/logos/societe-generale.svg';
import { ReactComponent as Dots } from '../../assets/svg/dots-h.svg';

// SVGs
import { ReactComponent as SVGplyrPlay } from '../../assets/svg/plyr-play.svg';

export default function Jumbotron({ children }) {
	const { mdx: page, i18NJson: i18n } = useStaticQuery(graphql`
		query {
			mdx(
				fields: {
					collection: { eq: "pages" }
					page: { eq: "home" }
					block: { eq: "description" }
				}
			) {
				body
			}
			i18NJson {
				ui {
					contactAlt
					solutionsAltHome
					clientsTitle
				}
			}
		}
	`);

	const [modalOpened, setModalOpened] = useState(false);

	const openModal = () => {
		setModalOpened(true);
	};

	const closeModal = () => {
		setModalOpened(false);
	};

	return (
		<div className="main-wrap">
			<div className="main-container">
				<div className="jumbotron">
					<h1 className="main-title">
						<KeywordRotator
							keywords={[
								'Digital',
								'Mobile',
								'Responsive',
								'Adaptive',
							]}
							interval={3000}
						/>
						<span className="kw2">Learning</span>
					</h1>
					<div className="jumbotron__content">
						<figure
							className="elearnis-reel-link"
							onClick={openModal}
						>
							<div className="picture">
								<img src={ReelSprites} loading="lazy" alt="" />
							</div>
							<figcaption>
								<button className="plyr__control plyr__control--overlaid">
									<span className="plyr__sr-only">Play</span>
									<SVGplyrPlay />
								</button>
							</figcaption>
						</figure>

						<div>
							<MarkdownContent>{page.body}</MarkdownContent>
						</div>
					</div>
				</div>

				<div className="actions">
					<Button
						href="/contact/"
						className="btn-lg btn-primary"
						sfx="rising-pops"
					>
						{i18n.ui.contactAlt}
						<i className="fa fa-arrow-right" aria-hidden="true"></i>
					</Button>
					<a
						href="#nos-solutions"
						className="btn btn-lg btn-outline"
						onClick={(e) => {
							const {
								currentTarget: { href },
							} = e;

							if (href.indexOf('#') === -1) {
								return;
							}

							e.preventDefault();
							const hash = href.substring(href.indexOf('#'));
							const element = document.querySelector(hash);

							if (element) {
								// Smooth scroll to the element
								element.scrollIntoView({
									behavior: 'smooth',
									block: 'start',
								});

								// Update URL with the hash without scrolling
								window.history.pushState(null, null, hash);
							}
						}}
					>
						{i18n.ui.solutionsAltHome}
					</a>
				</div>

				<div className="mouse"></div>

				<div className="trusted-by">
					<header>
						<h3>{i18n.ui.clientsTitle}</h3>
					</header>
					<ul className="logos">
						<li>
							<Link
								to={
									process.env
										.GATSBY_PAGES_TESTIMONIALS_SLUG ||
									'/testimonials/'
								}
							>
								<ApecLogo className="apec" />
							</Link>
						</li>
						<li>
							<Link
								to={
									process.env
										.GATSBY_PAGES_TESTIMONIALS_SLUG ||
									'/testimonials/'
								}
							>
								<ClarinsLogo className="clarins" />
							</Link>
						</li>
						<li>
							<Link
								to={
									process.env
										.GATSBY_PAGES_TESTIMONIALS_SLUG ||
									'/testimonials/'
								}
							>
								<VeoliaLogo className="veolia" />
							</Link>
						</li>
						<li>
							<Link
								to={
									process.env
										.GATSBY_PAGES_TESTIMONIALS_SLUG ||
									'/testimonials/'
								}
							>
								<SGLogo className="societe-generale" />
							</Link>
						</li>
						<li>
							<Link
								to={
									process.env
										.GATSBY_PAGES_TESTIMONIALS_SLUG ||
									'/testimonials/'
								}
							>
								<Dots className="dots" />
							</Link>
						</li>
					</ul>
				</div>
			</div>
			<div className="video-wrap">
				<video
					preload="auto"
					muted
					loop
					autoPlay
					playsInline
					poster={HomeVideoJPG}
				>
					<source src={HomeVideoWEBM} type="video/webm;codecs=vp9" />
					<source src={HomeVideoMP4} type="video/mp4" />

					<img src={HomeVideoJPG} alt="" loading="lazy" />
				</video>
			</div>

			{modalOpened && (
				<Portal>
					<>
						<div
							className="modal-backdrop fade in"
							onClick={closeModal}
						></div>
						<div className="modal modal-video fade in">
							<div className="modal-video-content">
								<button
									type="button"
									className="close"
									data-dismiss="modal"
									aria-label="close"
									onClick={closeModal}
								>
									<i className="fa fa-times"></i>
								</button>
								<div className="modal-video-embed">
									<div className="plyr__video-embed">
										<iframe
											title="video"
											id="yt_eRvk9JOoMns"
											src="https://www.youtube.com/embed/Fc-1XLjQfdY?autoplay=1&amp;modestbranding=1&amp;playsinline=0&amp;showinfo=0&amp;rel=0"
											allowfullscreen=""
											allowtransparency=""
											allow="autoplay"
											frameborder="0"
										/>
									</div>
								</div>
							</div>
						</div>
					</>
				</Portal>
			)}
		</div>
	);
}
